import { FBAbstractControl } from '../abstract.control';

export class FBControlsUnknownComponent {
  constructor() {}

  static PROPERTIES() {
    return Object.freeze({
      common: {
        ...FBAbstractControl.DefaultProperties(),
      },
      booleans: {
        ...FBAbstractControl.BooleansProperties(),
      },
    });
  }
}
